<template>
  <td>
    <nobr>
      <i class="fas fa-coins pr-1 fa-pull-left"></i>
      <span v-html="html"></span>
    </nobr>
  </td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
    props: ['content'],
    computed: {
      html () {
        return this.content !== null ? this.content : defaultNullHtml();
      }
    }
};
</script>
